<mat-table
  [dataSource]="items"
  [trackBy]="trackBy"
  matSort
  matSortDisableClear
  [matSortActive]="sort"
  [matSortDirection]="sortDirection"
  (matSortChange)="onSortChange($event)"
>
  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.name' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      {{ item.name }}
      <sn-icon size="sm" class="small-icon" *ngIf="item.isPrivate">lock</sn-icon>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="createdBy">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.createdBy' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      {{ this.formatName(item.createdBy?.firstName, item.createdBy?.lastName) }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="updatedBy">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.updatedBy' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      {{ this.formatName(item.updatedBy?.firstName, item.updatedBy?.lastName) }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="updatedTimestamp">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.updated' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      {{ item.updatedTimestamp | fsFormatDate : 'medium' }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="geometry">
    <mat-header-cell *matHeaderCellDef class="camera-grid-table-justify-content-center">{{ 'common.geometry' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item" class="camera-grid-table-justify-content-center">
      {{ item.geometry.cols }} × {{ item.geometry.rows }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="cameras">
    <mat-header-cell *matHeaderCellDef>{{ 'common.cameras' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-camera-stats [stats]="item.stats"></sn-camera-stats>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="owner">
    <mat-header-cell *matHeaderCellDef>{{ 'common.owner' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-object-owner [object]="item"></sn-object-owner>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="sharing">
    <mat-header-cell *matHeaderCellDef>{{ 'common.sharing' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-object-share-status [object]="item"></sn-object-share-status>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef>{{ 'common.actions' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-action-list [items]="actions" [context]="item" alwaysExpand></sn-action-list>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
  <mat-row
    matRipple
    [@snFadeIn]
    [@snFadeOut]
    (click)="onItemTap(item)"
    (doubletap)="onItemDblTap(item)"
    *matRowDef="let item; columns: columns"
  >
  </mat-row>
</mat-table>
